import { apiRegister } from '../../common/api'
// import { NO_ERROR } from '../../const'

export const slideImageLoad = apiRegister('slideImageLoad', {
  protoId: 986,
  path: '/xsh/config/cycleimglist/'
  // checkQuery(Q) {
  //   return NO_ERROR
  // },
  // formatResult(R) {
  //   return R
  // }
}).send

export const recommendListLoad = apiRegister('recommendListLoad', {
  protoId: 987,
  path: '/xsh/config/recommend/courselist/'
  // checkQuery(Q) {
  //   return NO_ERROR
  // },
  // formatResult(R) {
  //   return R
  // }
}).send

// 1008	xsh/config	/xsh/config/pagedata/	页面级数据 例：https://api-dev
export const homeModulesLoad = apiRegister('homeModulesLoad', {
  protoId: 1008,
  path: '/xsh/config/pagedata/',
  formatResult(R) {
    return R
  }
}).send

// 1009	xsh/config	/xsh/config/moduledata/	模块级数据
export const moduleInfoLoad = apiRegister('moduleInfoLoad', {
  protoId: 1009,
  path: '/xsh/config/moduledata/',
  formatResult(R) {
    return R
  }
}).send
